import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";

const PaymentShippingDetailCard = () =>{
    const { t } = useTranslation("products");
    
    const [shippingCompany, setShippingCompany] = React.useState('');
    const [shippingPaymentStatus, setShippingPaymentStatus] = React.useState('');
    const [isCustomShippingVisible, setIsCustomShippingVisible] = React.useState(false);
    const handleChange = (event) => {
        setShippingCompany(event.target.value);
      };

    const shippingPaymentStatushandleChange = (event) => {
        setShippingPaymentStatus(event.target.value);
      };
    
      const [shippingCompanies, setShippingCompanies] =  React.useState([
        'Kindersley Transport',
        'Ics',
        'Day & Ross',
        'UPS',
        'Loomis Express',
        'Fedex',
        'GLS',
        'Canada Post',
        'Canpar',
        'Nationex'
      ]);
      const [newShippingCompany, setNewShippingCompany] =  React.useState('');
  const handleAddShippingCompany = () => {
    if (newShippingCompany.trim() !== '') {
      setShippingCompanies([...shippingCompanies, newShippingCompany]);
      setNewShippingCompany('');
    }
    setIsCustomShippingVisible(!isCustomShippingVisible);
  };

  const handleNewShippingCompanyChange = (e) => {
    setNewShippingCompany(e.target.value);
  };

  const toggleCustShipVisibility = () => {
    setIsCustomShippingVisible(!isCustomShippingVisible);
  };
    return(
    <>
        <div className="paymentShipping__porductDetails_orderdetails">      
            <div className="paymentShipping__productDetails_main_wrap">
                <div className="paymentShipping__productDetails_header_main">
                    <h2>{t("addNew.payment.title")}</h2>
                </div>
                <div className="paymentShipping__orderDetails_body_main">
                    <div className='paymentShipping__order_status_radio'>
                        <FormControl className="paymentShipping_order_status_wrap">
                            <FormLabel id="paymentShipping_order_status"  className="paymentShipping_order_status_label">{t("addNew.payment.orderStatus")}</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="paymentShipping_order_status"
                                name="radio-buttons-group"
                                className="paymentShipping_order_status_radio_group"
                            >
                                <FormControlLabel className="paymentShipping_order_status_radio_group_pending"  value="pending" control={<Radio />} label={t("addNew.statuses.pending")} />
                                <FormControlLabel className="paymentShipping_order_status_radio_group_confirm" value="confirmed" control={<Radio />} label={t("addNew.payment.confirmed")} />
                                <FormControlLabel className="paymentShipping_order_status_radio_group_onhold" value="onhold" control={<Radio />} label={t("addNew.payment.onHold")} />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    <div className='paymentShipping__payment_status_radio'>
                        <FormControl  className='paymentShipping__payment_status_wrap'>
                            <FormLabel  className='paymentShipping__payment_status_label' id="paymentShipping__payment_status_radio">{t("addNew.payment.paymentStatus")}</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="paymentShipping__payment_status_radio"
                                name="radio-buttons-group"
                                className='paymentShipping__payment_status_group'
                            >
                                <FormControlLabel className='paymentShipping__payment_status_group_recieved' value="received" control={<Radio />} label={t("addNew.payment.received")} />
                                <FormControlLabel className='paymentShipping__payment_status_group_cop' value="cashOnPickup" control={<Radio />} label={t("addNew.payment.cashOnPickup")} />
                                <FormControlLabel className='paymentShipping__payment_status_group_cod' value="cashOnDelivery" control={<Radio />} label={t("addNew.payment.cashOnDelivery")} />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    <div className='paymentShipping__payment_amount_recandpay'>
                        <h3 className='paymentShipping__payment_recandpay_heading'>{t("addNew.payment.payableReceivable")}</h3>
                        <FormControl variant="outlined" className='paymentShipping__amount__received'>
                            <InputLabel htmlFor="paymentShipping__amount_received">
                            {t("addNew.payment.amountReceived")}
                            </InputLabel>
                            <OutlinedInput
                            id="paymentShipping__amount_received"
                            startAdornment={
                                <InputAdornment position="start">
                                $
                                </InputAdornment>
                            }
                            label={t("addNew.payment.amountReceived")}
                            />
                        </FormControl>
                        <FormControl variant="outlined"  className='paymentShipping__amount__pending'>
                            <InputLabel htmlFor="paymentShipping__amount_pending">
                            {t("addNew.payment.amountPending")}
                            </InputLabel>
                            <OutlinedInput
                            id="paymentShipping__amount_pending"
                            startAdornment={
                                <InputAdornment position="start">
                                $
                                </InputAdornment>
                            }
                            label={t("addNew.payment.amountPending")}
                            />
                        </FormControl>
                    </div>
                    <div className='paymentShipping__payment_amount_recandpay'>
                        <h3 className='paymentShipping__payment_recandpay_heading'>{t("addNew.payment.totalOrderAmount")}<span>{t("addNew.payment.sameAsTotal")}</span></h3>
                        <FormControl variant="outlined" className='paymentShipping__amount_total_wrap'>
                            <InputLabel htmlFor="paymentShipping__amount_total">
                            {t("addNew.payment.totalAmount")}
                            </InputLabel>
                            <OutlinedInput
                            id="paymentShipping__amount_total"
                            startAdornment={
                                <InputAdornment position="start">
                                $
                                </InputAdornment>
                            }
                            label={t("addNew.payment.totalAmount")}
                            />
                        </FormControl>
                        <FormControl variant="outlined" className='paymentShipping__amount_total_tax_wrap'>
                            <InputLabel htmlFor="paymentShipping__amount_total_tax">
                            {t("addNew.payment.totalTax")}
                            </InputLabel>
                            <OutlinedInput
                            id="paymentShipping__amount_total_tax"
                            startAdornment={
                                <InputAdornment position="start">
                                $
                                </InputAdornment>
                            }
                            label={t("addNew.payment.totalTaxLabel")}
                            />
                        </FormControl>
                        <FormControl variant="outlined" className='paymentShipping__amount_shipping_total_wrap'>
                            <InputLabel htmlFor="paymentShipping__amount_shipping_total">
                            {t("addNew.payment.shippingTotal")}
                            </InputLabel>
                            <OutlinedInput
                            id="paymentShipping__amount_shipping_total"
                            startAdornment={
                                <InputAdornment position="start">
                                $
                                </InputAdornment>
                            }
                            label={t("addNew.payment.shippingTotalLabel")}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>      
            <div className="paymentShipping__productDetails_main_wrap">
                <div className="paymentShipping__productDetails_header_main">
                    <h2>{t("addNew.shipping.title")}</h2>
                </div>
                <div className="paymentShipping__orderDetails_body_main">
                    <div className='paymentShipping__orderDetails_intro_content'>{t("addNew.shipping.intro")}</div>
                    <div className='paymentShipping__orderDetails_form_fields_block'>
                    <h3 className='paymentShipping__link_field_personal_record'>{t("addNew.shipping.records")}</h3>
                    <div className='paymentShipping__shipping_company'>
                            <FormControl variant="outlined">
                            <InputLabel id="demo-simple-select-label">{t("addNew.shipping.company")}</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={shippingCompany}
                                label={t("addNew.shipping.company")}
                                onChange={handleChange}
                            >
                                {shippingCompanies.map((company, index) => (
                                <MenuItem key={index} value={company}>
                                    {company}
                                </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
                            <div className='toggle__additional_Tax_btn' onClick={toggleCustShipVisibility} > +</div>
                            {isCustomShippingVisible && (
                            <div className='paymentShipping__shipping_company_add_more_panel_wrap'>
                                <div className='paymentShipping__shipping_company_add_more_overlay' onClick={toggleCustShipVisibility}></div>
                                <div className='paymentShipping__shipping_company_add_more_container'>
                                    <h3>{t("addNew.shipping.addCompany")}</h3>
                                    <div className='paymentShipping__shipping_company_add_more_body'>
                                    <TextField
                                    label={t("addNew.shipping.addMoreCompany")}
                                    value={newShippingCompany}
                                    onChange={handleNewShippingCompanyChange}
                                    />
                                        <Button variant="contained" onClick={handleAddShippingCompany}>
                                            {t("common:actions.add")}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                        <div className='paymentShipping__shipping_Tracking_code'>
                            <FormControl variant="outlined">
                                <InputLabel htmlFor="paymentShipping__tracking_code">
                                {t("addNew.shipping.trackingCode")}
                                </InputLabel>
                                <OutlinedInput
                                id="paymentShipping__tracking_code"
                                startAdornment={
                                    <InputAdornment position="start">
                                    </InputAdornment>
                                }
                                label={t("addNew.shipping.trackingCode")}
                                />
                            </FormControl>
                        </div>
                        <div className='paymentShipping__link_field'>
                            <FormControl variant="outlined">
                                <InputLabel htmlFor="paymentShipping__link">
                                {t("addNew.shipping.linkIfAny")}
                                </InputLabel>
                                <OutlinedInput
                                id="paymentShipping__link"
                                startAdornment={
                                    <InputAdornment position="start">
                                    </InputAdornment>
                                }
                                label={t("addNew.shipping.linkIfAny")}
                                />
                            </FormControl>
                        </div>
                        <h3 className='paymentShipping__link_field_personal_record'>{t("addNew.shipping.personalRecords")}</h3>
                        <div className='paymentShipping__paid__field'>
                            <FormControl variant="outlined">
                                <InputLabel htmlFor="paymentShipping__paid_field">
                                {t("addNew.shipping.paidOptional")}
                                </InputLabel>
                                <OutlinedInput
                                id="paymentShipping__paid_field"
                                startAdornment={
                                    <InputAdornment position="start">
                                    </InputAdornment>
                                }
                                label={t("addNew.shipping.paidOptional")}
                                />
                            </FormControl>
                        </div>
                       <div className='shipping__payment_status_field'>
                        <FormControl variant="outlined">
                                <InputLabel id="shipping__payment_status">{t("addNew.shipping.paymentStatus")}</InputLabel>
                                <Select
                                    labelId="shipping__payment_status"
                                    id="demo-simple-select"
                                    value={shippingPaymentStatus}
                                    label={t("addNew.shipping.paymentStatus")}
                                    onChange={shippingPaymentStatushandleChange}
                                >
                                    <MenuItem value={10}>{t("addNew.statuses.paid")}</MenuItem>
                                    <MenuItem value={20}>{t("addNew.statuses.unpaid")}</MenuItem>
                                    <MenuItem value={30}>{t("addNew.statuses.disputed")}</MenuItem>
                                    <MenuItem value={40}>{t("addNew.statuses.disputedWon")}</MenuItem>
                                    <MenuItem value={50}>{t("addNew.statuses.disputedLost")}</MenuItem>
                                    <MenuItem value={60}>{t("addNew.statuses.inProcess")}</MenuItem>
                                    <MenuItem value={70}>{t("addNew.statuses.pending")}</MenuItem>
                                </Select>
                            </FormControl>
                       </div>

                    </div>
                </div>
            </div>
        </div>
    </>
    )
}
export default PaymentShippingDetailCard;